// import React from 'react';
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom"; // Import Link from react-router-dom

import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";


import { Pagination, Autoplay, Navigation } from "swiper/modules";

const Home = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  // Dynamic card data
  const [cards] = useState([
    {
      title: "Data Analytics",
      link: "/data-analytics",
      backgroundImage: "./assets/img/2001.png",
    },
    {
      title: "Business Intelligence",
      link: "/business-intelligence",
      backgroundImage: "./assets/img/2002.png",
    },
    {
      title: "Data Engineering",
      link: "/data-engineering",
      backgroundImage: "./assets/img/2003.png",
    },
    {
      title: "Machine Learning & AI",
      link: "/artificial-intelligence",
      backgroundImage: "./assets/img/2004.png",
    },
    {
      title: "Software Development",
      link: "/software-development",
      backgroundImage: "./assets/img/2005.png",
    },
    {
      title: "Mobile Apps Development",
      link: "/apps-development",
      backgroundImage: "./assets/img/2006.png",
    },

    {
      title: "Resource Outsourcing",
      link: "/resource-outsource",
      backgroundImage: "./assets/img/2007.png",
    },

    {
      title: "Training",
      link: "/training",
      backgroundImage: "./assets/img/2008.png",
    },
  ]);

  const [showAll, setShowAll] = useState(false);

  // Toggle See More / See Less
  const toggleShowAll = () => {
    setShowAll(!showAll);
  };

  return (
    <div>
      <section id="center" style={{ padding: 0 }}>
        <div className="container-fluid" style={{ padding: 0 }}>
          <Swiper
            pagination={{
              dynamicBullets: true,
            }}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            modules={[Pagination, Autoplay]}
            className="mySwiper"
            style={{ width: "100%" }}
          >
            <SwiperSlide style={{ position: "relative", height: "620px" }}>
              {/* Overlay */}
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)", // Transparent overlay
                  zIndex: 1,
                }}
              ></div>
              <img
                src="./assets/img/banner1.jpg"
                alt="Slide 1"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              {/* Text Content */}
              <div
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "10%",
                  color: "#fff",
                  zIndex: 2,
                  textAlign: "left",
                }}
              >
                <h1 style={{ margin: 0, fontSize: "3rem" }}>
                  Driving Success <br /> with Advanced Analytics
                </h1>
                <p style={{ margin: "10px 0", paddingBottom: "15px" }}>
                  Empowering enterprises to achieve their goals seamlessly.
                </p>

                <Link
                  to="/contact"
                  style={{
                    textDecoration: "none", // Ensures the link has no underline
                  }}
                >
                  <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let's Talk <span className="arrow">→</span>
            </Link>
          </button>
                </Link>
              </div>
            </SwiperSlide>

            <SwiperSlide style={{ position: "relative", height: "620px" }}>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1,
                }}
              ></div>
              <img
                src="./assets/img/banner2.png"
                alt="Slide 2"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "10%",
                  color: "#fff",
                  zIndex: 2,
                  textAlign: "left",
                }}
              >
                <h1 style={{ margin: 0, fontSize: "3rem" }}>
                  Transforming Businesses <br /> Through Technology
                </h1>
                <p style={{ margin: "10px 0", paddingBottom: "15px" }}>
                  Delivering innovative solutions for a digital future.
                </p>

                <Link
                  to="/contact"
                  style={{
                    textDecoration: "none", // Ensures the link has no underline
                  }}
                >
                  <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let's Talk <span className="arrow">→</span>
            </Link>
          </button>
                </Link>
              </div>
            </SwiperSlide>

            <SwiperSlide style={{ position: "relative", height: "620px" }}>
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                  zIndex: 1,
                }}
              ></div>
              <img
                src="./assets/img/banner3.png"
                alt="Slide 3"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "20%",
                  left: "10%",
                  color: "#fff",
                  zIndex: 2,
                  textAlign: "left",
                }}
              >
                <h1 style={{ margin: 0, fontSize: "3rem" }}>
                  Analytics-Driven <br /> Insights for Smarter Decisions
                </h1>
                <p style={{ margin: "10px 0", paddingBottom: "15px" }}>
                  Turn your data into actionable intelligence with ease.
                </p>

                <Link
                  to="/contact"
                  style={{
                    textDecoration: "none", // Ensures the link has no underline
                  }}
                >
                  <button className="banner-button mt-3">
            <Link to="/contact" className="text-decoration-none text-white">
              Let's Talk <span className="arrow">→</span>
            </Link>
          </button>
                </Link>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>

      <section
        id="serv_h"
        className="p_3"
        style={{ backgroundColor: "black", color: "white" }}
      >
        <div className="container-fluid" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4">
            <div className="col-md-9">
              <div className="serv_h1l">
                <h3>Transforming businesses</h3>
                <p className="mb-0">
                  Driving growth with software and analytics expertise
                </p>
              </div>
            </div>
          </div>

          <div className="my-swiper-container" style={{ height: "500px" }}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={16}
              loop={true}
              navigation={{
                nextEl: ".my-swiper-button-next",
                prevEl: ".my-swiper-button-prev",
              }}
              pagination={{ clickable: true }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 16,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 20,
                },
              }}
            >
              <SwiperSlide
                className="my-slider-slide"
                style={{
                  backgroundImage: "url(./assets/img/1001.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  position: "relative",
                }}
              >
                <div
                  className="slide-text"
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.6)",
                    color: "white",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <h4>Innovating for Tomorrow</h4>
                  <p>
                    Empowering businesses with cutting-edge software and
                    analytics solutions.
                  </p>
                  <Link
                    to="/innovating-for-tomorrow"
                    className="see-more-btn"
                    style={{
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "transparent",
                      border: "2px solid white",
                      color: "white",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      textDecoration: "none",
                      display: "inline-block",
                    }}
                  >
                    See More{" "}
                    <span style={{ marginLeft: "10px", fontSize: "18px" }}>
                      →
                    </span>
                  </Link>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="my-slider-slide"
                style={{
                  backgroundImage: "url(./assets/img/1002.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  position: "relative",
                }}
              >
                <div
                  className="slide-text"
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <h4>Data-Driven Decisions</h4>
                  <p>
                    Harnessing analytics to turn insights into actionable
                    strategies.
                  </p>
                  <Link
                    to="/data-driven-decisions" // Replace with your desired route
                    className="see-more-btn"
                    style={{
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "transparent",
                      border: "2px solid white",
                      color: "white",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      textDecoration: "none", // Removes underline
                      display: "inline-block",
                    }}
                  >
                    See More{" "}
                    <span style={{ marginLeft: "10px", fontSize: "18px" }}>
                      →
                    </span>
                  </Link>
                </div>
              </SwiperSlide>

              <SwiperSlide
                className="my-slider-slide"
                style={{
                  backgroundImage: "url(./assets/img/1003.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  position: "relative",
                }}
              >
                <div
                  className="slide-text"
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <h3>Empowering Growth</h3>
                  <p>
                    Innovative solutions designed to help businesses scale and
                    succeed.
                  </p>
                  <Link
                    to="/empowering-growth" // Replace with the route you want
                    className="see-more-btn"
                    style={{
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "transparent",
                      border: "2px solid white",
                      color: "white",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      textDecoration: "none", // Removes underline
                      display: "inline-block",
                    }}
                  >
                    See More{" "}
                    <span style={{ marginLeft: "10px", fontSize: "18px" }}>
                      →
                    </span>
                  </Link>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="my-slider-slide"
                style={{
                  backgroundImage: "url(./assets/img/1004.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  position: "relative",
                }}
              >
                <div
                  className="slide-text"
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <h3>Future-Ready Solutions</h3>
                  <p>
                    Preparing your business for tomorrow's challenges with
                    innovative tech.
                  </p>
                  <Link
                    to="/future-ready-solutions" // Replace with your route
                    style={{
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "transparent",
                      border: "2px solid white",
                      color: "white",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      textDecoration: "none", // Removes underline
                    }}
                  >
                    See More{" "}
                    <span style={{ marginLeft: "10px", fontSize: "18px" }}>
                      →
                    </span>
                  </Link>
                </div>
              </SwiperSlide>
              <SwiperSlide
                className="my-slider-slide"
                style={{
                  backgroundImage: "url(./assets/img/1005.png)",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "100%",
                  position: "relative",
                }}
              >
                <div
                  className="slide-text"
                  style={{
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    width: "100%",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    color: "white",
                    padding: "20px",
                    textAlign: "center",
                  }}
                >
                  <h3>Streamlining Processes</h3>
                  <p>
                    Optimizing workflows with custom software and automation
                    tools.
                  </p>
                  <Link
                    to="/streamlining-processes" // Replace with your route
                    style={{
                      marginTop: "10px",
                      padding: "10px 20px",
                      backgroundColor: "transparent",
                      border: "2px solid white",
                      color: "white",
                      cursor: "pointer",
                      fontSize: "16px",
                      fontWeight: "bold",
                      borderRadius: "5px",
                      textDecoration: "none",
                    }}
                  >
                    See More{" "}
                    <span style={{ marginLeft: "10px", fontSize: "18px" }}>
                      →
                    </span>
                  </Link>
                </div>
              </SwiperSlide>
              {/* Repeat for other slides */}
            </Swiper>
            <div className="my-swiper-button-prev"></div>
            <div className="my-swiper-button-next"></div>
          </div>
        </div>
      </section>

      <section className="bg-light">
        <div className="container-fluid" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4">
            <div className="col-md-9">
              <div className="serv_h1l">
                <h3>Specify your industry type</h3>
                <p className="mb-0">
                  Tailored Solutions for Your Industry's Success
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-university me-3 fs-4 text-black"></i>
              <Link
                to="/banking"
                className="text-decoration-none text-dark fs-5"
              >
                Banking
              </Link>
            </div>

            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-graduation-cap me-3 fs-4 text-black"></i>
              <Link
                to="/education"
                className="text-decoration-none text-dark fs-5"
              >
                Education
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-hospital me-3 fs-4 text-black"></i>
              <Link
                to="/healthcare"
                className="text-decoration-none text-dark fs-5"
              >
                Healthcare
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-shield-alt me-3 fs-4 text-black"></i>
              <Link
                to="/insurance"
                className="text-decoration-none text-dark fs-5"
              >
                Insurance
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-industry me-3 fs-4 text-black"></i>
              <Link
                to="/manufacturing"
                className="text-decoration-none text-dark fs-5"
              >
                Manufacturing
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-shopping-cart me-3 fs-4 text-black"></i>
              <Link
                to="/retail"
                className="text-decoration-none text-dark fs-5"
              >
                Retail
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-chart-line me-3 fs-4 text-black"></i>
              <Link
                to="/capital-markets"
                className="text-decoration-none text-dark fs-5"
              >
                Capital Markets
              </Link>
            </div>
            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-box me-3 fs-4 text-black"></i>
              <Link
                to="/consumer-goods"
                className="text-decoration-none text-dark fs-5"
              >
                Fast-Moving Consumer Goods
              </Link>
            </div>

            <div className="col-md-4 d-flex align-items-center shadow_box py-2 mb-3">
              <i className="fas fa-users me-3 fs-4 text-black"></i>
              <Link
                to="/public-services"
                className="text-decoration-none text-dark fs-5"
              >
                Public Services
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* <section class="container py-5">
  <div class="row g-4">
   
    <div className="col-md-3">
  <div
    className="card text-white bg-dark border-0 rounded-3 shadow"
    style={{
      backgroundImage: "url('https://brainstation-23.com/wp-content/uploads/2021/01/web_cover_final_V2.jpg')", // Replace with your image path
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "300px",
    }}
  >
    <div className="card-img-overlay d-flex align-items-end p-3">
      <h5 className="card-title text-white fw-bold">Artificial Intelligence</h5>
    </div>
  </div>
</div>

<div className="col-md-3">
  <div
    className="card text-white bg-dark border-0 rounded-3 shadow"
    style={{
      backgroundImage: "url('https://brainstation-23.com/wp-content/uploads/2021/01/web_cover_final_V2.jpg')", // Replace with your image path
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "300px",
    }}
  >
    <div className="card-img-overlay d-flex align-items-end p-3">
      <h5 className="card-title text-white fw-bold">Artificial Intelligence</h5>
    </div>
  </div>
</div>

<div className="col-md-3">
  <div
    className="card text-white bg-dark border-0 rounded-3 shadow"
    style={{
      backgroundImage: "url('https://brainstation-23.com/wp-content/uploads/2021/01/web_cover_final_V2.jpg')", // Replace with your image path
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "300px",
    }}
  >
    <div className="card-img-overlay d-flex align-items-end p-3">
      <h5 className="card-title text-white fw-bold">Artificial Intelligence</h5>
    </div>
  </div>
</div>

<div className="col-md-3">
  <div
    className="card text-white bg-dark border-0 rounded-3 shadow"
    style={{
      backgroundImage: "url('https://brainstation-23.com/wp-content/uploads/2021/01/web_cover_final_V2.jpg')", // Replace with your image path
      backgroundSize: "cover",
      backgroundPosition: "center",
      height: "300px",
    }}
  >
    <div className="card-img-overlay d-flex align-items-end p-3">
      <h5 className="card-title text-white fw-bold">Artificial Intelligence</h5>
    </div>
  </div>
</div>

<div class="row serv_h4 mt-4 text-center">
    <div class="col-md-12">
      <h6 class="mb-0">
        <a class="button" href="#" onclick="loadMoreCards()">See More</a>
      </h6>
    </div>
  </div>



  </div>
</section> */}

      {/* <section className="container py-5">
      <div className="row g-4">
       
        {cards.map((card, index) => (
          <div className="col-md-3" key={index}>
            <div
              className="card text-white bg-dark border-0 rounded-3 shadow"
              style={{
                backgroundImage: `url(${card.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '300px',
              }}
            >
              <div className="card-img-overlay d-flex align-items-end p-3">
                <h5 className="card-title text-white fw-bold">{card.title}</h5>
              </div>
            </div>
          </div>
        ))}
      </div>

      
      <div className="row serv_h4 mt-4 text-center">
        <div className="col-md-12">
          <h6 className="mb-0">
            <button style={{border: 'none'}} className="button" onClick={loadMoreCards}>See More</button>
          </h6>
        </div>
      </div>
    </section> */}

      <section
        className="container-fluid"
        style={{ padding: 40, background: "black", color: "white" }}
      >
        <div className="row serv_h1 mb-4">
          <div className="col-md-9">
            <div className="serv_h1l">
              <h3>SERVICES</h3>
              <p className="mb-0">
                Transform your business with advanced technologies
              </p>
            </div>
          </div>
        </div>
        <div className="row g-4">
          {cards.slice(0, showAll ? cards.length : 4).map((card, index) => (
            <div className="col-md-3" key={index}>
              <div
                className="card text-white bg-dark border-0 rounded-3 shadow"
                style={{
                  backgroundImage: `url('${card.backgroundImage}')`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  height: "300px",
                }}
              >
                <div
                  className="card-img-overlay d-flex align-items-end p-3"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }} // Adding transparency to background
                >
                  <Link
                    to={card.link}
                    className="card-title text-white fw-bold"
                  >
                    {card.title}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* See More / See Less button */}
        <div className="row serv_h4 mt-4 text-center">
          <div className="col-md-12">
            <h6 className="mb-0">
              <button
                style={{ border: "none" }}
                className="button"
                onClick={toggleShowAll}
              >
                {showAll ? "See Less" : "See More"}
              </button>
            </h6>
          </div>
        </div>
      </section>

      <div class="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4">
          <div className="col-md-9">
            <div className="serv_h1l">
              <h3>Products and platforms</h3>
              <p className="mb-0">Driving Success with Cutting-Edge Tools</p>
            </div>
          </div>
        </div>

        <div class="row g-4">
          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
                <Link to="/transaction-analytics">Transaction Analytics</Link>
              </h3>
              <p class="mb-4">
                Transaction Analytics uncovers trends, optimizes operations, and
                drives data-driven decisions.
              </p>
              <Link
                to="/transaction-analytics"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </Link>
            </div>
          </div>

          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
              <Link to="#">Device Financing Platform</Link>
              </h3>
              <p class="mb-4">
                The Device Financing Platform uses AI to offer personalized
                payment plans, evaluate credit scores.
              </p>
              <Link
                to="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </Link>
            </div>
          </div>

          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
              <Link to="#">Online Job Portal</Link>
              </h3>
              <p class="mb-4">
                The Online Job Portal connects job seekers and employers,
                enabling job search and application management.
              </p>
              <Link
                to="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </Link>
            </div>
          </div>

          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
              <Link to="#">HR Management</Link>
              </h3>
              <p class="mb-4">
                HR Management oversees recruitment, performance, payroll, and
                other functions to ensure efficiency and satisfaction.
              </p>
              <Link
                to="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </Link>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
              <Link to="#">Hospital Management</Link>
              </h3>
              <p class="mb-4">
                Hospital Management manages patient care, staff, billing, and
                inventory for efficient healthcare delivery.
              </p>
              <Link
                to="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </Link>
            </div>
          </div>
          <div class="col-md-6">
            <div class="p-4 border rounded bg-white card-hover">
              <h3 class="mb-3 card-title">
              <Link to="#">Wholesale Distribution Platform</Link>
              </h3>
              <p class="mb-4">
                Wholesale Distribution Platform streamlines bulk orders,
                inventory, and distribution for suppliers.
              </p>
              <Link
                to="#"
                class="text-decoration-none text-primary fw-bold fs-5"
              >
                &rarr;
              </Link>
            </div>
          </div>
        </div>
      </div>

      <section
        className=""
        style={{ backgroundColor: "black", color: "white" }}
      >
        <div className="container-fluid" style={{ padding: 40 }}>
          <div className="row serv_h1 mb-4">
            <div className="col-md-9">
              <div className="serv_h1l">
                <h3>Blogs</h3>
                <p className="mb-0">Insights That Inspire and Inform</p>
              </div>
            </div>
          </div>
          <div className="row g-4">
            {/* Blog Card 1 */}
            <div className="col-md-4">
              <div className="card custom-card">
                <img
                  src="./assets/img/2005.png "
                  className="card-img"
                  alt="Newsroom"
                />
                <div className="card-label">Software Development</div>
                <div
                  className="card-overlay"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                >
                  <h5 className="card-title">
                    Web and App Development: The Crucial Role of JavaScript
                  </h5>
                  <Link
                    to="/blog-Details1"
                    className="read-more text-light text-decoration-none"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Additional Blog Cards (repeat as needed) */}
            <div className="col-md-4">
              <div className="card custom-card">
                <img
                  src="./assets/img/3002.png"
                  className="card-img"
                  alt="Analyst Relations"
                />
                <div className="card-label">AI and Machine Learning</div>
                <div
                  className="card-overlay"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                >
                  <h5 className="card-title">
                    Revolutionizing Data Analytics with AI and Machine Learning
                  </h5>
                  <Link
                    to="/blog-Details"
                    className="read-more text-light text-decoration-none"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Blog Card 2 */}
            <div className="col-md-4">
              <div className="card custom-card">
                <img
                  src="./assets/img/3003.png"
                  className="card-img"
                  alt="Press Release"
                />
                <div className="card-label">Data Analytics</div>
                <div
                  className="card-overlay"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                >
                  <h5 className="card-title">
                    The Power of Data Visualization: Unveiling Insights Beyond
                    Numbers
                  </h5>
                  <Link
                    to="/blog-Details2"
                    className="read-more text-light text-decoration-none"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>

            {/* Blog Card 3 */}
            {/* <div className="col-md-4">
              <div className="card custom-card">
                <img
                  src="https://freerangestock.com/sample/121186/back-view…oking-at-an-office-presentation-in-the-office.jpg"
                  className="card-img"
                  alt="Analyst Relations"
                />
                <div className="card-label">Software Development</div>
                <div
                  className="card-overlay"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                >
                  <h5 className="card-title">
                    Web and App Development: The Crucial Role of JavaScript
                  </h5>
                  <Link
                    to="/blog-Details3"
                    className="read-more text-light text-decoration-none"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div> */}

            {/* Repeat for other cards */}
            {/* <div className="col-md-4">
              <div className="card custom-card">
                <img
                  src="https://freerangestock.com/sample/121186/back-view…oking-at-an-office-presentation-in-the-office.jpg"
                  className="card-img"
                  alt="Analyst Relations"
                />
                <div className="card-label">Analyst Relations</div>
                <div
                  className="card-overlay"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                >
                  <h5 className="card-title">
                    Analysts recognize TCS as a cross-industry leader
                  </h5>
                  <Link
                    to="/blog-Details4"
                    className="read-more text-light text-decoration-none"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div> */}

            {/* Repeat for other cards */}
            {/* <div className="col-md-4">
              <div className="card custom-card">
                <img
                  src="https://freerangestock.com/sample/121186/back-view…oking-at-an-office-presentation-in-the-office.jpg"
                  className="card-img"
                  alt="Analyst Relations"
                />
                <div className="card-label">Analyst Relations</div>
                <div
                  className="card-overlay"
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.4)" }}
                >
                  <h5 className="card-title">
                    Analysts recognize TCS as a cross-industry leader
                  </h5>
                  <Link
                    to="/blog-Details5"
                    className="read-more text-light text-decoration-none"
                  >
                    Read More <i className="fas fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
      <div className="container-fluid" style={{ padding: 40 }}>
        <div className="row serv_h1 mb-4 text-center">
          <div className="col-md-12">
            <div className="serv_h1l">
              <h3>Our Clients</h3>
              <p className="mb-0">Trusted by Industry Leaders</p>
            </div>
          </div>
        </div>

        <div className="my-swiper-container" style={{ position: "relative" }}>
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={16}
            loop={true}
            navigation={{
              nextEl: ".my-swiper-button-next",
              prevEl: ".my-swiper-button-prev",
            }}
            pagination={{
              clickable: true,
              el: ".swiper-pagination", 
            }}
            breakpoints={{
              320: {
                slidesPerView: 2,
                spaceBetween: 10,
              },
              768: {
                slidesPerView: 3,
                spaceBetween: 16,
              },
              1024: {
                slidesPerView: 4,
                spaceBetween: 16,
              },
              1200: {
                slidesPerView: 5,
                spaceBetween: 20,
              },
            }}
          >
            
            <SwiperSlide>
              <img
                src="./assets/img/logo-ilm.png"
                alt="Client Logo 6"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/myhealth.png"
                alt="Client Logo 6"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/oracle.png"
                alt="Client Logo 1"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/a2i.png"
                alt="Client Logo 2"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/ict.png"
                alt="Client Logo 3"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/wind-lunge-sm.png"
                alt="Client Logo 4"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/upay.png"
                alt="Client Logo 5"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/ngdt.png"
                alt="Client Logo 6"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>

            <SwiperSlide>
              <img
                src="./assets/img/logo-edubriq.png"
                alt="Client Logo 6"
                style={{
                  width: "120px",
                  height: "80px",
                  objectFit: "contain",
                  margin: "auto",
                }}
              />
            </SwiperSlide>
          </Swiper>

          {/* Next Button with Modern Design */}
          <div
            className="my-swiper-button-next"
            style={{
              position: "absolute",
              top: "50%",
              right: "5px", 
              transform: "translateY(-50%)",
              zIndex: 10,
              cursor: "pointer",
              width: "30px", 
              height: "30px", 
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.9)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <span
              style={{
                color: "#fff",
                fontSize: "20px", 
                fontWeight: "bold",
                transition: "all 0.3s ease",
              }}
            >
              &rarr;
            </span>
          </div>

          {/* Prev Button with Modern Design */}
          <div
            className="my-swiper-button-prev"
            style={{
              position: "absolute",
              top: "50%",
              left: "5px", 
              transform: "translateY(-50%)",
              zIndex: 10,
              cursor: "pointer",
              width: "30px", 
              height: "30px", 
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.9)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
              e.currentTarget.style.transform = "translateY(-50%) scale(1)";
            }}
          >
            <span
              style={{
                color: "#fff",
                fontSize: "20px", 
                fontWeight: "bold",
                transition: "all 0.3s ease",
              }}
            >
              &larr;
            </span>
          </div>

          {/* Pagination Container with Inline Styles */}
          <div
            className="swiper-pagination"
            style={{
              position: "absolute",
              bottom: "5px", 
              left: "50%",
              transform: "translateX(-50%)",
              zIndex: 10,
              display: "flex",
              justifyContent: "center",
              gap: "6px", 
            }}
          ></div>
        </div>
      </div>
    </section>
    </div>
  );
};

export default Home;
